import * as Yup from 'yup'

const sendPaymentSchema = Yup.object({
    amount:Yup.number().required().moreThan(0.9, 'INPUT.VALIDATION.AMOUNT.ADD.ERROR'),
    description:Yup.string().required("INPUT.VALIDATION.PAYMENT.TYPE.SELECT")
})
export {sendPaymentSchema}